module.exports = __webpack_public_path__ + "static/AR3-30e629c452ea9963d05753dd6d21f12b.jpg";